import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, CategoriaGasto, SearchCategoriaGastoRequest, SearchCategoriaGastoResponse, SaveCategoriaGastoDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class CategoriaGastoService extends CrudService<CategoriaGasto, number, SaveCategoriaGastoDto, SearchCategoriaGastoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'categoriaGasto', sharedFunctions);

  }
}